export const COMFY_API_BASE_URL = __USE_PROD_CONFIG__
  ? 'https://api.comfy.org'
  : 'https://stagingapi.comfy.org'

export const COMFY_PLATFORM_BASE_URL = __USE_PROD_CONFIG__
  ? 'https://platform.comfy.org'
  : 'https://stagingplatform.comfy.org'
